module.exports = __webpack_public_path__ + "static/media/download.f53f192b.svg";